module.exports = __webpack_public_path__ + "img/fr.248f685c.svg";